import { api } from 'api';
import { user } from './user';
import { notify } from 'libs/common';

/**
 * update roles in local storage
 */
const updateRoles = () => {
  api
    .call('roles.list')
    .then((data) => {
      user.updateRoles(data.items);
    })
    .catch((error) => notify('updateRoles', error));
};

/**
 * add
 * @param {*} data
 * @returns
 */
export const addRole = (data) => {
  return api.call('roles.add', data).then((data) => {
    updateRoles();
    return data;
  });
};

/**
 * update
 * @param {*} data
 * @returns
 */
export const updateRole = (data) => {
  return api.call('roles.update', data).then((data) => {
    updateRoles();
    return data;
  });
};

/**
 * delete role
 * @param {*} id
 * @returns
 */
export const deleteRole = (id) => {
  return api.call('roles.delete', { id }).then((data) => {
    updateRoles();
    return data;
  });
};

/**
 * update permission for role
 * @param {*} role_id
 * @param {*} id
 * @param {*} value
 * @returns
 */
export const updatePermission = (role_id, id, value) => {
  return api.call('roles.change_permission', { role_id, permission_id: id, is_allowed: value });
};
